const api = {
    transactionsTotal: 'data/transactions/total_count', //交易总量
    txCharts: 'data/transactions/charts', //交易统计
    ledgers: 'data/ledgers/list',//区块高度列表
    cLedgers: 'data/ledgers/c_list',//区块高度列表
    ledgerDetail: 'data/ledgers/detail', //区块高度详情
    transactions: 'data/transactions/origin_list',//交易记录
    cTransactions: 'data/transactions/c_origin_list',//交易记录
    transactionDetail: 'data/transactions/origin_detail', //交易记录详情
    accounts: 'data/accounts/transactions/list', //账户交易记录

    balances: 'data/accounts/base_balance',
    secondBalances:'data/accounts/token_balances', 
    gatewayBalances: 'data/accounts/gateway_balances',

    secondCurrencyList: 'charger/currency/list', //二级通证列表
    secondCurrencyDetail: 'charger/currency/detail', //二级通证详情
    secondCurrencyProportion: 'data/state/account_tokens', //二级通证比例
    currencyChart: 'data/currency/charts', //二级通证详情chart

    contractCodeDetail: 'rpc/smart_contract/contract_code',
    contractQuery: 'rpc/smart_contract/contract_query',

}

export default api